<clr-main-container>
  <clr-header class="header-6 ndbx-header">
      <div class="branding">
          <a routerLink="/" class="sg-allianz-logo-inverted">Allianz</a>
          <!-- <a routerLink="/" class="logo-and-title">
              <span class="title">Angular NDBX</span>
          </a> -->
      </div>
      <div class="divider"></div>
      <div class="header-nav" [clr-nav-level]="1">
          <!-- <a id="home-link" class="nav-link" routerLink="/" routerLinkActive="active" [routerLinkActiveOptions]="{exact:true}"><span class="nav-text">Home</span></a>-->
          <!-- <a class="nav-link" routerLink="/news" routerLinkActive="active"><span class="nav-text">News</span></a> -->
          <a class="nav-link" routerLink="/get-started" routerLinkActive="active"><span class="nav-text">Get Started</span></a>
          <a class="nav-link" routerLink="/documentation/pfe" routerLinkActive="active"><span class="nav-text">Live Demo</span></a>
          <a class="nav-link" routerLink="/editor" routerLinkActive="active"><span class="nav-text">Config Editor</span></a>
          <a class="nav-link" href="./assets/docs/index.html" routerLinkActive="active"><span class="nav-text">Developer Documentation</span></a>
      </div>
      <div class="settings">
      </div>
      <div class="ndbx-github__icon-holder" onclick="window.open('https://github.developer.allianz.io/ilt/ngx-pfe', '_blank')">
        <img alt="github" class="ndbx-github__icon" src="assets/logos/github-circle-white-transparent.svg" >
        GitHub
      </div>
  </clr-header>

  <router-outlet></router-outlet>
</clr-main-container>
